import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import { Box, Modal, Tooltip } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";
import { BiSolidVolumeMute } from "react-icons/bi";
import { GoUnmute } from "react-icons/go";
import * as yup from "yup";
// import { CloseIcon } from "../../assets/icons/CustomIcons";
// import CommonButton from "../../common/components/Buttons/CommonButton";
// import ConfirmationModal from "../../common/components/ConfirmationModal";
// import InputField from "../../common/components/FormFields/InputField";
// import SearchDropdown from "../../common/components/FormFields/searchDropdown";
// import { acknowledgeAttention } from "../PatientMonitoringServices";
import { CloseIcon } from "../../../assets/icons/CustomIcons";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import InputField from "../../../common/components/FormFields/InputField";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import { successAlert } from "../../../common/components/Toasts/CustomToasts";

const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  height: "75%",
  overflowY: "auto",
  bgcolor: "black",
  border: "3px solid red",
  borderRadius: "5px",
  boxShadow: 50,
  zIndex: 999,
  p: 2,
};

function ClinicalCareAttentionModal(props) {
  const [acknowledgementType, setAcknowledgementType] = React.useState("");
  const [isAcknowledgement, setIsAcknowledgement] = React.useState(false);
  const [employeeOptions, setEmployeeOptions] = React.useState([]);
  const loggedUser = JSON.parse(localStorage.getItem("userInfo"));
  const [openPost, setOpenPost] = React.useState(false);
  const [finalData, setFinalData] = React.useState(null);

  const handleClosePost = () => {
    if (openPost === true) {
      setOpenPost(false);
    }
  };
  const [muteType, setMuteType] = React.useState("");
  const [isMute, setIsMute] = React.useState(false);
  console.log("mmmuuuuu :", isMute);

  const defaultValues = {
    acknowledgementBy: "",
    acknowledgementRemarks: "",
  };

  const schema = yup.object().shape({
    acknowledgementBy: yup.object().required(),
    acknowledgementRemarks: yup.string().required,
  });

  const {
    control,
    watch,
    setValue,
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange",
    defaultValues: defaultValues,
    // resolver: yupResolver(schema),
  });

  let remarkField = watch("acknowledgementRemarks");

  React.useEffect(() => {
    let employeeObject = {
      id: loggedUser?.empId,
      label: loggedUser?.userName,
      value: loggedUser?.empId,
    };
    setValue("acknowledgementBy", employeeObject);
  }, [props?.open]);

  const handleGetEmployees = (searchString) => {
    if (searchString !== "") {
    }
  };

  const onSubmitData = (data) => {
    // let postObject = {
    //   mute: muteType !== "" ? true : false,
    //   admissionId: props?.selectedBed?.admissionid,
    //   vital:
    //     acknowledgementType === "heartRate"
    //       ? "HEARTRATE"
    //       : acknowledgementType === "spo2"
    //         ? "SPO2"
    //         : acknowledgementType === "respiration"
    //           ? "RESPIRATION"
    //           : acknowledgementType === "bp"
    //             ? "BP"
    //             : "",
    //   remarks: data?.acknowledgementRemarks,
    //   employeeId: data?.acknowledgementBy?.id,
    // };
    successAlert("Acknowledged !");
    props?.handleCloseCCCAttentionModal();
    // setFinalData(postObject);
  };

  React.useEffect(() => {
    if (finalData !== null) {
      setOpenPost(true);
    }
  }, [finalData]);

  const handleAcknowledge = () => {
    successAlert("Acknowledged !");
    handleClosePost();
    // acknowledgeAttention(finalData)
    //   .then((response) => response?.data)
    //   .then((res) => {
    //     successAlert(res?.message);
    //     setFinalData(null);
    //     setMuteType("");
    //     handleClosePost();
    //     setAcknowledgementType("");
    //     setIsAcknowledgement(false);
    //     reset(defaultValues);
    //   });
  };

  const handleMute = (isMute, type) => {
    setIsMute(isMute);
    let postObject = {
      mute: isMute,
      admissionId: props?.selectedBed?.admissionid,
      vital: type,
      remarks: remarkField,
      employeeId: loggedUser?.empId,
    };

    // setFinalData(postObject);
  };

  return (
    <div>
      <Modal
        BackdropProps={{
          sx: {
            backdropFilter: "blur(5px)",
            WebkitBackdropFilter: "blur(7px)",
            backgroundColor: "rgba(0,0,0,0.55)", // dim outside
          },
        }}
        open={props?.open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={ModalStyle} className="bg-black">
          <form onSubmit={handleSubmit(onSubmitData)}>
            <div className="grid grid-cols-3 gap-2 items-center">
              <div></div>
              <div className="text-[2rem] flex justify-center text-customOrange  font-semibold tracking-wide whitespace-nowrap ">
                Attention Required..!
              </div>
              <div className="flex justify-end">
                <button
                  className="mt-1"
                  type="button"
                  onClick={() => {
                    props?.handleCloseCCCAttentionModal();
                  }}
                >
                  <CloseIcon />
                </button>
              </div>
            </div>
            <hr className="mx-10 bg-sky-300 border border-sky-300 my-2" />
            <div className="grid grid-cols-3 gap-2 items-center pl-4">
              <div className="flex gap-2 items-center text-zinc-200">
                <div className="text-lg font-bold">Bed No.</div>
                <div className="text-lg font-semibold">
                  {/* : {props?.selectedBed?.["bedno"]} */}: {"407"}
                </div>
              </div>
              <div className="flex gap-2 items-center col-span-2 text-zinc-200">
                <div className="text-lg font-bold">Patient Name</div>
                <div className="text-lg font-bold">
                  {/* : {props?.selectedBed?.["patientname"]} */}:{" "}
                  {"Mrs . BEATRICE PILLAI"}
                </div>
              </div>
            </div>
            <div className="my-5">&nbsp;</div>
            {/* {props?.selectedBed !== undefined &&
            props?.selectedBed?.bp !== null ? ( */}
            <div
              className={`grid grid-cols-3 gap-2 items-center pl-4 ${props?.selectedBed?.bpalert?.toLowerCase() === "critical" || props?.selectedBed?.bpalert?.toLowerCase() === "high" ? `text-red-700` : props?.selectedBed?.bpalert?.toLowerCase() === "warning" ? `text-yellow-600` : props?.selectedBed?.bpalert?.toLowerCase() === "normal" ? `text-green-600` : `text-white`} font-semibold text-xl my-5`}
            >
              <div className="flex gap-2 items-center col-span-2 text-[1.5rem] text-yellow-600">
                <div className="w-32 text-yellow-600">BP</div>
                <div>: {"117 /  63"} (mmHg)</div>
              </div>
              {props?.selectedBed?.bpalert?.toLowerCase() === "critical" ||
              props?.selectedBed?.bpalert?.toLowerCase() === "high" ? (
                <div className="flex gap-6 items-center justify-center">
                  <div>
                    {props?.selectedBed?.bpmute === true ? (
                      <Tooltip title="Unmute">
                        <button
                          type="button"
                          onClick={() => {
                            setMuteType("bp");
                            setIsMute(false);
                            handleMute(false, "BP");
                            handleSubmit(onSubmitData);
                          }}
                        >
                          <GoUnmute className="text-customOrange text-[2rem]" />
                        </button>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Mute">
                        <button
                          type="button"
                          onClick={() => {
                            setMuteType("bp");
                            handleMute(true, "BP");
                            setIsMute(true);
                            handleSubmit(onSubmitData);
                          }}
                        >
                          <BiSolidVolumeMute className="text-customOrange text-[2rem]" />
                        </button>
                      </Tooltip>
                    )}
                  </div>
                  <div>
                    <Tooltip title="Acknowledge">
                      <button
                        type="button"
                        onClick={() => {
                          setMuteType("");
                          setIsAcknowledgement(true);
                          setAcknowledgementType("bp");
                        }}
                      >
                        <ThumbUpAltIcon
                          sx={{
                            color: "oklch(72.3% 0.219 149.579)",
                            fontSize: "2rem",
                          }}
                        />
                      </button>
                    </Tooltip>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            {/* ) : (
              ""
            )} */}

            {/* {props?.selectedBed !== undefined &&
            props?.selectedBed?.respiration !== null ? ( */}
            <div
              className={`grid grid-cols-3 gap-2 items-center pl-4 ${props?.selectedBed?.respalert?.toLowerCase() === "critical" || props?.selectedBed?.respalert?.toLowerCase() === "high" ? `text-red-700` : props?.selectedBed?.respalert?.toLowerCase() === "warning" ? `text-yellow-600` : props?.selectedBed?.respalert?.toLowerCase() === "normal" ? `text-green-600` : `text-white`} font-semibold text-xl my-5`}
            >
              <div className="flex gap-2 items-center col-span-2 text-[1.5rem] text-red-700">
                <div className="w-32">Respiration</div>
                <div>: {"27"} (bpm)</div>
              </div>
              {/* {props?.selectedBed?.respalert?.toLowerCase() === "critical" ||
                props?.selectedBed?.respalert?.toLowerCase() === "high" ? ( */}
              <div className="flex gap-6 items-center justify-center">
                <div>
                  {props?.selectedBed?.respirationmute === false ? (
                    <Tooltip title="Mute">
                      <button
                        type="button"
                        onClick={() => {
                          setMuteType("respiration");
                          handleMute(true, "RESPIRATION");
                          setIsMute(true);
                          handleSubmit(onSubmitData);
                        }}
                      >
                        <BiSolidVolumeMute className="text-customOrange text-[2rem]" />
                      </button>
                    </Tooltip>
                  ) : (
                    <Tooltip title="Unmute">
                      <button
                        type="button"
                        onClick={() => {
                          setMuteType("respiration");
                          handleMute(false, "RESPIRATION");
                          setIsMute(false);
                          handleSubmit(onSubmitData);
                        }}
                      >
                        <GoUnmute className="text-customOrange text-[2rem]" />
                      </button>
                    </Tooltip>
                  )}
                </div>
                <div>
                  <Tooltip title="Acknowledge">
                    <button
                      type="button"
                      onClick={() => {
                        setMuteType("");
                        setIsAcknowledgement(true);
                        setAcknowledgementType("respiration");
                      }}
                    >
                      <ThumbUpAltIcon
                        sx={{
                          color: "oklch(72.3% 0.219 149.579)",
                          fontSize: "2rem",
                        }}
                      />
                    </button>
                  </Tooltip>
                </div>
              </div>
              {/* ) : (
                  ""
                )} */}
            </div>
            {/* ) : (
              ""
            )} */}
            {/* {props?.selectedBed !== undefined &&
            props?.selectedBed?.spo2val !== null ? ( */}
            <div
              className={`grid grid-cols-3 gap-2 items-center pl-4 ${props?.selectedBed?.spoalert?.toLowerCase() === "critical" || props?.selectedBed?.spoalert?.toLowerCase() === "high" ? `text-red-700` : props?.selectedBed?.spoalert?.toLowerCase() === "warning" ? `text-yellow-600` : props?.selectedBed?.spoalert?.toLowerCase() === "normal" ? `text-green-600` : `text-white`} font-semibold text-xl my-5`}
            >
              <div className="flex gap-2 items-center col-span-2 text-[1.5rem] text-red-600">
                <div className="w-32">SpO2</div>
                <div>: {"76"} (%)</div>
              </div>
              {props?.selectedBed?.spoalert?.toLowerCase() === "critical" ||
              props?.selectedBed?.spoalert?.toLowerCase() === "high" ? (
                <div className="flex gap-6 items-center justify-center">
                  <div>
                    {props?.selectedBed?.spo2mute === true ? (
                      <Tooltip title="Unmute">
                        <button
                          type="button"
                          onClick={() => {
                            setMuteType("spo2");
                            handleMute(false, "SPO2");
                            setIsMute(false);
                            handleSubmit(onSubmitData);
                          }}
                        >
                          <GoUnmute className="text-customOrange text-[2rem]" />
                        </button>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Mute">
                        <button
                          type="button"
                          onClick={() => {
                            setMuteType("spo2");
                            handleMute(true, "SPO2");
                            setIsMute(true);
                            handleSubmit(onSubmitData);
                          }}
                        >
                          <BiSolidVolumeMute className="text-customOrange text-[2rem]" />
                        </button>
                      </Tooltip>
                    )}
                  </div>
                  <div>
                    <Tooltip title="Acknowledge">
                      <button
                        type="button"
                        onClick={() => {
                          setMuteType("");
                          setIsAcknowledgement(true);
                          setAcknowledgementType("spo2");
                        }}
                      >
                        <ThumbUpAltIcon
                          sx={{
                            color: "oklch(72.3% 0.219 149.579)",
                            fontSize: "2rem",
                          }}
                        />
                      </button>
                    </Tooltip>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            {/* ) : (
              ""
            )} */}
            {/* {props?.selectedBed !== undefined &&
            props?.selectedBed?.heartrate !== null ? ( */}
            <div
              className={`grid grid-cols-3 gap-2 items-center pl-4 ${props?.selectedBed?.heartratealert?.toLowerCase() === "critical" || props?.selectedBed?.heartratealert?.toLowerCase() === "high" ? `text-red-700` : props?.selectedBed?.heartratealert?.toLowerCase() === "warning" ? `text-yellow-600` : props?.selectedBed?.heartratealert?.toLowerCase() === "normal" ? `text-green-600` : `text-white`}   font-semibold text-xl my-5`}
            >
              <div className="flex gap-2 items-center col-span-2 text-[1.5rem] text-green-600">
                <div className="w-32">Heart Rate</div>
                <div>: {"92"} (bpm)</div>
              </div>
              {props?.selectedBed?.heartratealert?.toLowerCase() ===
                "critical" ||
              props?.selectedBed?.heartratealert?.toLowerCase() === "high" ? (
                <div className="flex gap-6 items-center justify-center">
                  <div>
                    {props?.selectedBed?.heartratemute === true ? (
                      <Tooltip title="Unmute">
                        <button
                          type="button"
                          onClick={() => {
                            setMuteType("heartRate");
                            handleMute(false, "HEARTRATE");
                            setIsMute(false);
                            handleSubmit(onSubmitData);
                          }}
                        >
                          <GoUnmute className="text-customOrange text-[2rem]" />
                        </button>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Mute">
                        <button
                          type="button"
                          onClick={() => {
                            setMuteType("heartRate");
                            handleMute(true, "HEARTRATE");
                            setIsMute(true);
                            handleSubmit(onSubmitData);
                          }}
                        >
                          <BiSolidVolumeMute className="text-customOrange text-[2rem]" />
                        </button>
                      </Tooltip>
                    )}
                  </div>
                  <div>
                    <Tooltip title="Acknowledge">
                      <button
                        type="button"
                        onClick={() => {
                          setMuteType("");
                          setIsAcknowledgement(true);
                          setAcknowledgementType("heartRate");
                        }}
                      >
                        <ThumbUpAltIcon
                          sx={{
                            color: "oklch(72.3% 0.219 149.579)",
                            fontSize: "2rem",
                          }}
                        />
                      </button>
                    </Tooltip>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            {/* ) : (
              ""
            )} */}
            {/* {isAcknowledgement === true || muteType !== "" ? ( */}
            <div>
              <hr className="border border-sky-300 my-5 bg-sky-300 mx-10" />
              {acknowledgementType === "heartRate" ? "" : ""}
              <div className="text-lg font-semibold text-lime-100 pl-4 ">
                Acknowledgement :
              </div>
              <div className="my-4 px-4">
                <SearchDropdown
                  error={errors?.acknowledgementBy}
                  control={control}
                  searchIcon={true}
                  handleInputChange={handleGetEmployees}
                  name={"acknowledgementBy"}
                  placeholder={`${acknowledgementType === "heartRate" ? `Heart Rate` : acknowledgementType === "spo2" ? `SpO2` : acknowledgementType === "respiration" ? `Respiration` : acknowledgementType === "bp" ? `BP` : ``} Acknowledged By`}
                  dataArray={employeeOptions}
                />
                <div className="flex justify-end gap-2 items-center mt-4">
                  <InputField
                    error={errors?.acknowledgementRemarks}
                    control={control}
                    name={"acknowledgementRemarks"}
                    label={"Remarks"}
                  />
                </div>
                <div className="flex justify-end gap-2 items-center my-3">
                  <CommonButton
                    label={"Acknowledge"}
                    type={"submit"}
                    className={
                      "px-3 rounded-lg bg-gradient-to-r from-lime-600 via-lime-700 to-lime-800 text-white"
                    }
                  />
                </div>
              </div>
            </div>
            {/* ) : (
              ""
            )} */}
          </form>{" "}
          {/* <ConfirmationModal
            confirmationOpen={openPost}
            confirmationHandleClose={handleClosePost}
            confirmationSubmitFunc={handleAcknowledge}
            confirmationLabel="Confirmation"
            confirmationMsg={`Do you want to ${isMute === false ? "Unmute" : isMute === true ? "Mute" : muteType === "" ? "Acknowledge" : ""} ?`}
            confirmationButtonMsg={`${isMute === false ? "Unmute" : isMute === true ? "Mute" : muteType === "" ? "Acknowledge" : ""} `}
          /> */}
        </Box>
      </Modal>
    </div>
  );
}

export default ClinicalCareAttentionModal;
